import User from "./user";
import RoleService from "./role";
import PermissionService from "./permission";
import DomainService from "./domain";
import Manager from "./manager";
import NotificationService from "./notification";
import SettingService from "./settings";
import LeaveService from "./leave";
import MyProjectService from "./myproject";
import TravelService from "./travel";

const userService = new User();
const roleService = new RoleService();
const permissionService = new PermissionService();
const domainService = new DomainService();
const managerService = new Manager();
const notificationService = new NotificationService();
const settingService = new SettingService();
const leaveService = new LeaveService();
const travelService = new TravelService();
const myProjectService = new MyProjectService();


export {
    userService, roleService, permissionService, domainService,
    managerService, notificationService, leaveService, settingService,
    myProjectService, travelService
}